import React from 'react';
import Modal from 'shared/modals/Modal';
import BaseButton, { CancelButton } from '../../../../shared/components/buttons';

const OrderHazmatApprovalModal = ({ onClose, title, message, canCreatePendingOrder }) => {
  return (
    <Modal isOpen={true} title={title} handleClose={() => onClose(false)} containerStyle='medium'>
      <section style={{ padding: '1rem' }}>{message}</section>
      {canCreatePendingOrder && (
        <>
          <div className='k-form-buttons' style={{ padding: '0.5rem' }}>
            <BaseButton primary title='Send to Safety' onClick={() => onClose(true)} />
            <CancelButton onClick={() => onClose(false)} style={{ marginTop: 0, marginLeft: '1rem' }} />
          </div>
        </>
      )}
    </Modal>
  );
};

export default OrderHazmatApprovalModal;
